import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  labelRootError: {
    color: 'red !important',
  },
  labelRootSuccess: {
    color: 'green !important',
  },
  underlineError: {
    '&:after': {
      borderColor: 'red',
    },
  },
  underlineSuccess: {
    '&:after': {
      borderColor: 'green',
    },
  },
  underline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: 'gray !important',
      borderWidth: '1px !important',
    },
    '&:after': {
      borderColor: 'blue',
    },
    '& + p': {
      fontWeight: '300',
    },
  },
  labelRoot: {
    color: 'gray !important',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '1.42857',
    top: '6px',
    letterSpacing: 'unset',
    paddingLeft: '5px',
  },
  input: {
    fontWeight: '300',
    lineHeight: '1.5em',
  },
  whiteInput: {
    '&,&::placeholder': {
      color: 'rgba(255,255,255,.8) !important',
    },
  },
  whiteInputWithBlackPlaceholder: {
    color: 'black !important',
    '&::placeholder': {
      color: 'rgba(0,0,0,0.6) !important',
    },
  },
  labelRootBase: {
    color: 'black !important',
  },
  labelRootWhiteBase: {
    color: 'white !important',
  },
  formControl: {
    margin: '0',
    paddingLeft: '5px',
    paddingRight: '5px',
    position: 'relative',
    verticalAlign: 'unset',
    '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
      color: 'gray',
    },
  },
  inputAdornment: {
    height: '40px',
  },
  disabled: {
    '&:before': {
      borderColor: 'transparent !important',
    },
  },
}));
